module.exports = __webpack_public_path__ + "a2219aa4c0e3674ccecb2b396eb4b9e7.MP3";